module.exports = __webpack_public_path__ + "static/media/ed-agile-eq.9bd3f473.png";